import React, { useEffect, useRef, useState } from "react";
import { Box, Grid, Typography, styled } from "@mui/material";
import image1 from "../../../../assets/programme/empoweringimage.jpeg";
import image2 from "../../../../assets/programme/bannerimage2.jpeg";

// import image3 from "../../../../assets/updatedBannerImage/blogcard3.jpg";
import Footer from "../../../../common/Footer";
import Header from "../../../../common/Header";
import { useNavigate } from "react-router-dom";

const ScrollContainer = styled("div")(({ theme }) => ({
  display: "flex",
  overflowX: "auto",
  overflowY: "hidden",
  scrollSnapType: "x mandatory",
  scrollBehavior: "smooth",
  height: "100%",
  width: "100%",
  position: "relative",
  margin: 0,
  padding: 0,
  scrollbarWidth: "none",
  msOverflowStyle: "none",
  "&::-webkit-scrollbar": {
    display: "none",
  },
  [theme.breakpoints.down("md")]: {
    height: "100%",
    width: "100%",
  },
}));

const ScrollItem = styled("div")({
  flex: "0 0 100%",
  scrollSnapAlign: "start",
  height: "100%",
  position: "relative",
  margin: 0,
  padding: 0,
});

const ScrollImage = styled("img")({
  width: "100%",
  height: "100%",
  objectFit: "cover",
  display: "block",
  margin: 0,
  padding: 0,
});

const DotsContainer = styled("div")({
  position: "absolute",
  bottom: "20px",
  left: "50%",
  transform: "translateX(-50%)",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  gap: "10px",
  zIndex: 10,
  pointerEvents: "auto",
});

const Dot = styled("div")(({ active }) => ({
  width: "12px",
  height: "12px",
  borderRadius: "50%",
  cursor: "pointer",
  backgroundColor: active ? "#fff" : "rgba(255,255,255,0.5)",
  transition: "background-color 0.3s ease",
  "&:hover": {
    backgroundColor: "white",
    transform: "scale(1.2)",
  },
}));



const EmpoweringCommunities = () => {
  useEffect(() => {
    window.scroll(0, 0);
  }, []);
  const navigate = useNavigate();
  const images = [image1,  image2];


  const Dot = styled("div")(({ active }) => ({
    width: "12px",
    height: "12px",
    borderRadius: "50%",
    cursor: "pointer",
    backgroundColor: active ? "#fff" : "rgba(255,255,255,0.5)",
    transition: "background-color 0.3s ease",
    "&:hover": {
      backgroundColor: "white",
      transform: "scale(1.2)",
    },
  }));

  const scrollRef = useRef(null);
  const [currentIndex, setCurrentIndex] = useState(0);

  const handleDotClick = (index) => {
    const container = scrollRef.current;
    if (!container) return;
    const scrollWidth = container.scrollWidth;
    const itemWidth = scrollWidth / images.length;
    container.scrollTo({ left: itemWidth * index, behavior: "smooth" });
    setCurrentIndex(index);
  };

  const handleScroll = () => {
    const container = scrollRef.current;
    if (!container) return;
    const scrollLeft = container.scrollLeft;
    const itemWidth = container.offsetWidth;
    const index = Math.round(scrollLeft / itemWidth);
    setCurrentIndex(index);
  };

  useEffect(() => {
    const container = scrollRef.current;
    if (container) {
      container.addEventListener("scroll", handleScroll);
    }
    return () => {
      if (container) {
        container.removeEventListener("scroll", handleScroll);
      }
    };
  }, []);


  useEffect(() => {
    const container = scrollRef.current;
    const interval = setInterval(() => {
      const nextIndex = (currentIndex + 1) % images.length;
      setCurrentIndex(nextIndex);
      container.scrollTo({
        left: container.clientWidth * nextIndex,
        behavior: "smooth",
      });
    }, 5000);

    return () => clearInterval(interval);
  }, [currentIndex, images.length]);

  useEffect(() => {
    const container = scrollRef.current;
    if (!container) return;

    const handleScroll = () => {
      const scrollWidth = container.scrollWidth;
      const itemWidth = scrollWidth / images.length;
      const newIndex = Math.round(container.scrollLeft / itemWidth);
      setCurrentIndex(newIndex);
    };

    container.addEventListener("scroll", handleScroll);
    return () => container.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      const nextIndex = (currentIndex + 1) % images.length;
      handleDotClick(nextIndex);
    }, 5000);

    return () => clearInterval(interval);
  }, [currentIndex]);



  return (
    <>
      <Grid container>
        <Header />

        {/* Hero Section */}
        <Grid
          item
          xs={12}
          md={12}
          sx={{
            width: "100%",
            height: { xs: "50vh", md: "65vh" },
            position: "relative",
          }}
        >
          <ScrollContainer ref={scrollRef}>
            {images.map((img, index) => (
              <ScrollItem key={index}>
                <ScrollImage src={img} alt={`Banner ${index + 1}`} />
              </ScrollItem>
            ))}
          </ScrollContainer>

          <DotsContainer>
            {images.map((_, idx) => (
              <Dot
                key={idx}
                active={currentIndex === idx}
                onClick={() => handleDotClick(idx)}
              />
            ))}
          </DotsContainer>
        </Grid>

        {/* Content Section Below */}
        <Grid item md={12} xs={12}>
          <Grid
            sx={{
              //   bgcolor: "#151d1f",
              color: "#7f6b56",
              // height: '100vh',
              fontFamily: "Inter, sans-serif",
              px: 3,
              py: 6,
              position: "relative",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            {/* Main Content */}
            <Box maxWidth="md" textAlign="center">
              <Typography
                variant="h4"
                fontWeight="bold"
                gutterBottom
                sx={{ fontFamily: "Montserrat, sans-serif" }}
              >
                Restoring Hope, One Coral at a Time
              </Typography>

              <Typography
                variant="body1"
                gutterBottom
                sx={{
                  mt: 2,
                  lineHeight: 1.6,
                  fontFamily: "Montserrat, sans-serif",
                  textAlign: "left",
                  fontSize: "20px",
                  fontWeight: "500",
                }}
              >
                The fragile coral reefs of the Lakshadweep Archipelago are a
                lifeline for island communities—providing food, coastal
                protection, and livelihoods. However, rising sea temperatures,
                destructive fishing practices, and climate change have led to
                severe reef degradation across the atolls. In response to this
                ecological crisis, REEF launched{" "}
                <strong>The Reef Restoration Project</strong>—a community-driven
                initiative aimed at reviving coral reef ecosystems through
                science-based restoration and sustainable stewardship.
              </Typography>
              <Typography
                variant="body1"
                gutterBottom
                sx={{
                  mt: 2,
                  lineHeight: 1.6,
                  fontFamily: "Montserrat, sans-serif",
                  textAlign: "left",
                  fontSize: "20px",
                  fontWeight: "500",
                }}
              >
                Here is a comprehensive and engaging **website content draft**
                for your *Seagrass Restoration Project in Lakshadweep*. This can
                be used for the homepage or a dedicated project page:
              </Typography>
              <Typography
                variant="h5"
                fontWeight="medium"
                gutterBottom
                sx={{
                  fontFamily: "Montserrat, sans-serif",
                  mt: 4,
                  textAlign: "left",
                  fontSize: "20px",
                  fontWeight: "500",
                }}
              >
                Seagrass Restoration Project – Lakshadweep Archipelago
              </Typography>

              <Typography
                variant="body1"
                gutterBottom
                sx={{
                  mt: 2,
                  lineHeight: 1.6,
                  fontFamily: "Montserrat, sans-serif",
                  textAlign: "left",
                  fontSize: "20px",
                  fontWeight: "500",
                }}
              >
                The Seagrass Restoration Project in Lakshadweep is a pioneering
                conservation initiative dedicated to restoring and protecting
                the vital seagrass ecosystems of this unique coral atoll region.
                Spearheaded by REEF (Research and Environmental Education
                Foundation), in collaboration with local communities,
                researchers, and policy advocates, the project aims to revive
                degraded seagrass meadows, strengthen marine biodiversity, and
                enhance the climate resilience of the archipelago.
              </Typography>

              <Typography
                variant="h6"
                fontWeight="bold"
                gutterBottom
                sx={{
                  mt: 3,
                  fontFamily: "Montserrat, sans-serif",
                  textAlign: "left",
                  fontSize: "20px",
                  fontWeight: "500",
                }}
              >
                Why Seagrass Matters
              </Typography>

              <Typography
                variant="body1"
                gutterBottom
                sx={{
                  lineHeight: 1.6,
                  fontFamily: "Montserrat, sans-serif",
                  textAlign: "left",
                  fontSize: "20px",
                  fontWeight: "500",
                }}
              >
                Often overlooked, seagrass meadows are underwater powerhouses.
                They:
              </Typography>

              <ul
                style={{
                  textAlign: "left",
                  lineHeight: 1.6,
                  paddingLeft: "1.2em",
                  fontFamily: "Montserrat, sans-serif",
                }}
              >
                <li>
                  Provide critical nursery grounds for fish, including
                  commercially important and endangered species.
                </li>
                <li>Stabilize sediment and protect coastlines from erosion.</li>
                <li>Improve water clarity and support coral health.</li>
                <li>
                  Act as powerful carbon sinks, helping to mitigate climate
                  change.
                </li>
              </ul>

              <Typography
                variant="body1"
                gutterBottom
                sx={{
                  mt: 2,
                  lineHeight: 1.6,
                  fontFamily: "Montserrat, sans-serif",
                  textAlign: "left",
                  fontSize: "20px",
                  fontWeight: "500",
                }}
              >
                In the Lakshadweep Archipelago, these habitats are crucial for
                the livelihoods of local communities dependent on fishing and
                coastal resources.
              </Typography>

              <Typography
                variant="h6"
                fontWeight="bold"
                gutterBottom
                sx={{
                  mt: 3,
                  fontFamily: "Montserrat, sans-serif",
                  textAlign: "left",
                }}
              >
                Our Objectives
              </Typography>

              <ul
                style={{
                  textAlign: "left",
                  lineHeight: 1.6,
                  paddingLeft: "1.2em",
                  fontFamily: "Montserrat, sans-serif",
                }}
              >
                <li>
                  <strong>Ecological Restoration:</strong> Restore degraded
                  seagrass meadows through transplantation and natural
                  recruitment methods.
                </li>
                <li>
                  <strong>Community Engagement:</strong> Train and involve local
                  youth, fishers, and school students in seagrass monitoring and
                  restoration.
                </li>
                <li>
                  <strong>Research and Monitoring:</strong> Conduct scientific
                  assessments to understand seagrass distribution, health, and
                  associated biodiversity.
                </li>
                <li>
                  <strong>Awareness and Advocacy:</strong> Build awareness among
                  policymakers and the public about the ecological and economic
                  value of seagrass ecosystems.
                </li>
              </ul>

              <Typography
                variant="h6"
                fontWeight="bold"
                gutterBottom
                sx={{
                  mt: 3,
                  fontFamily: "Montserrat, sans-serif",
                  textAlign: "left",
                  fontSize: "20px",
                  fontWeight: "500",
                }}
              >
                Community at the Heart
              </Typography>

              <Typography
                variant="body1"
                gutterBottom
                sx={{
                  mt: 2,
                  lineHeight: 1.6,
                  fontFamily: "Montserrat, sans-serif",
                  textAlign: "left",
                  fontSize: "20px",
                  fontWeight: "500",
                }}
              >
                Our approach is deeply rooted in the belief that lasting
                conservation is only possible when local communities are
                empowered. The project actively trains community volunteers as
                "Seagrass Guardians" who participate in mapping, transplanting,
                and long-term monitoring of the meadows. Their traditional
                knowledge, combined with modern science, forms the backbone of
                our success.
              </Typography>

              <Typography
                variant="h6"
                fontWeight="bold"
                gutterBottom
                sx={{
                  mt: 3,
                  fontFamily: "Montserrat, sans-serif",
                  textAlign: "left",
                  fontSize: "20px",
                  fontWeight: "500",
                }}
              >
                Be Part of the Change
              </Typography>

              <Typography
                variant="body1"
                gutterBottom
                sx={{
                  mt: 2,
                  lineHeight: 1.6,
                  fontFamily: "Montserrat, sans-serif",
                  textAlign: "left",
                }}
              >
                Join us in restoring Lakshadweep's underwater meadows. Whether
                you're a student, diver, scientist, policymaker, or concerned
                citizen—there’s a role for you.
              </Typography>

              <Typography
                variant="body1"
                sx={{
                  mt: 2,
                  fontStyle: "italic",
                  fontFamily: "Montserrat, sans-serif",
                  textAlign: "left",
                  fontSize: "20px",
                  fontWeight: "500",
                }}
              >
                Together, we can protect this hidden treasure of the Indian
                Ocean.
              </Typography>
              {/* <Typography
                variant="h6"
                sx={{
                  mt: 2,
                  fontStyle: "italic",
                  textAlign: "center",
                  fontWeight: "600",
                }}
              >
                Check Out These Recommended Blog Posts
              </Typography> */}
            </Box>
          </Grid>
        </Grid>
        <Box sx={{ maxWidth: 700, margin: "0 auto", pX: 3, pb: 2 }}>
          <Grid container spacing={5}>
            {/* First Image with Text */}
            {/* <Grid item xs={12} md={6}>
              <img
                src={image2}
                alt="Nature"
                style={{
                  width: "100%",
                  height: "200px",
                  objectFit: "cover",
                  //   borderRadius: "8px",
                  marginBottom: "10px",
                }}
              />
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <Typography
                  variant="h6"
                  sx={{ fontWeight: "bold", mr: 1, cursor: "pointer" }}
                  onClick={() => navigate("/biodiversity-of-lakshadweep")}
                >
                  Biodiversity of Lakshadweep: A Living Laboratory of Island
                  Ecosystems
                </Typography>
              </Box>
            </Grid> */}

            {/* Second Image with Text */}
            {/* <Grid item xs={12} md={6}>
              <img
                src={image3}
                alt="Nature"
                style={{
                  width: "100%",
                  height: "200px",
                  objectFit: "cover",
                  //   borderRadius: "8px",
                  marginBottom: "10px",
                }}
              />
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <Typography
                  variant="h6"
                  sx={{ fontWeight: "bold", mr: 1, cursor: "pointer" }}
                  onClick={() => navigate("/restoring-hope")}
                >
                  Restoring Hope, One Coral at a Time
                </Typography>
              </Box>
            </Grid> */}
          </Grid>
        </Box>
      </Grid>
      <Footer variant="light" />
    </>
  );
};

export default EmpoweringCommunities;
